import type { ActiveGameData } from '@ps/web-poker-types';

import type { ActiveGamesState } from '../../types';

import { defaultState } from './activeGames';

export const reducers = {
  set: (
    state: ActiveGamesState,
    payload: ActiveGamesState['games'] = defaultState.games
  ): ActiveGamesState => ({
    ...state,
    games: payload
  }),
  remove: (state: ActiveGamesState, payload: string[] = []): ActiveGamesState => {
    const games: ActiveGameData[] = state.games.filter((game) => !payload.includes(`${game.id}`));

    return {
      ...state,
      games
    };
  },
  clear: (state: ActiveGamesState): ActiveGamesState => ({
    ...state,
    games: []
  })
};
